import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss'],
  animations: [
    trigger('openClose', [
      state('collapsed', style({ height: '0', 'overflow-y': 'hidden' })),
      state('expanded', style({ height: '*' })),
      transition('collapsed => expanded', [
        animate('300ms', style({ height: '*', 'overflow-y': 'hidden' }))
      ]),
    ]),
  ]
})
export class PartnersComponent implements OnInit {

  xList = [{"name":"a","number":"1","date":"1360413309421","class":"purple"},{"name":"b","number":"5","date":"1360213309421","class":"orange"},{"name":"c","number":"10","date":"1360113309421","class":"blue"},{"name":"d","number":"2","date":"1360113309421","class":"green"},{"name":"e","number":"6","date":"1350613309421","class":"green"},{"name":"f","number":"21","date":"1350613309421","class":"orange"},{"name":"g","number":"3","date":"1340613309421","class":"blue"},{"name":"h","number":"7","date":"1330613309001","class":"purple"},{"name":"i","number":"22","date":"1360412309421","class":"blue"}];

  partnersList = [
    {
      logo: 'netgrif_full_grey.svg',
      link: 'https://netgrif.com/',
      type: 'bpm',
      desc: '<strong>NETGRIF</strong> is a low-code digital platform enabling digital transformation for businesses of any size.  The unique approach to business process management helps to easily automate, orchestrate and integrate business process with only a fraction of the investments otherwise needed for similar solutions to get started.'
    },
    {
      logo: 'predevlogo_black.png',
      link: 'https://pre.dev/',
      type: 'software-planning',
      desc: '<strong>pre.dev’s</strong> technology accelerates idea to development by extracting an instant project plan from a collaborative, guided conversation with an AI Product Expert. It integrates seamlessly with popular PM tools to bring project plans to life and provides access to rapid development through a network of engineers.'
    },
    {
      logo: '9envoylogocorrectCapture-e1663040198476-1.jpg',
      link: 'https://9envoy.com/',
      type: 'consulting',
      desc: '<strong>9Envoy Technologies</strong> works with forward-looking organizations who understand that joining the global startup economy is key to drive innovation and spur economic growth. 9Envoy offers global workforce solutions in strategic planning and IT services that understand you, your business and key stakeholders.'
    },
    {
      logo: 'api-people-logo2-1.svg',
      link: 'https://apipeople.com/',
      type: 'consulting',
      desc: '<strong>API People</strong> provide technology agnostic solutions for integrating backend solutions in the financial services sector. With specialist knowledge understanding the unique challenges that credit unions, banks and fintech companies face with integrating to banking core, API People provide advisory services, API strategy, project delivery and managed support.'
    },
    {
      logo: '6452469286cf31e5f3d0ab5f_99099759_image-230x108.jpg',
      link: 'https://archimasolutions-sf.com/',
      type: 'consulting',
      desc: '<strong>Archima Solutions</strong> is a boutique Salesforce Professional Services firm, working closely with businesses to provide custom-designed integrated sourcing strategies to help smooth variances in the workload, fill intermittent gaps and boost productivity. Tailored to suit Cloud Implementation Services, Managed and Remote Innovation and Strategic Staffing Services.'
    },
    {
      logo: 'logo-01-1-768x143.png',
      link: 'https://integralzone.com/',
      type: 'code-analysis',
      desc: '<strong>Integral Zone</strong> offers code scanning, real-time API health monitoring, and accelerators to empower companies developing with MuleSoft to reduce their development costs by promoting best practices and limiting the footprint on technical debt. With integrated SAST code scanning, and design tools, the Falcon Suite is a key part of the development lifecycle.'
    },
    {
      logo: 'revenium_small_54968ec611-1.svg',
      type: 'api-monetization',
      link: 'https://www.revenium.io/',
      desc: '<strong>Revenium</strong> accelerates digital product delivery, revenue generation and ROI with their “zero-code” installation, compatible with all major API management platforms. Advanced monetization capabilities, flexible go-to-market tools, and next-gen observability make Revenium the ideal solution for companies seeking to turn ideas into income.'
    }
  ];

  selectedType = '';

  typesList = [
    {text:'SELECT ALL',value:''},
    {text:'API Monetization',value:'api-monetization'},
    {text:'BPM',value:'bpm'},
    {text:'Code Analysis',value:'code-analysis'},
    {text:'Consulting',value:'consulting'},
    {text:'Software Planning',value:'software-planning'}
  ]

  constructor() { }

  ngOnInit(): void {
  }

  selectChanged(event:any): void {
    this.selectedType = event;
  }

}
